import { useState } from 'react'

import { Dialog, Text } from '@loadsmart/miranda-react'

import { type Thread } from 'assistant/domain/Thread'
import { displayTitle } from 'assistant/domain/threadTitle'

type DeleteThreadDialogProps = {
  thread: Thread
  onConfirm: () => Promise<void>
  onClose: () => void
}

export default function DeleteThreadDialog({ thread, onConfirm, onClose }: DeleteThreadDialogProps) {
  const [message, setMessage] = useState('')
  const [isDeleting, setIsDeleting] = useState(false)

  async function confirm() {
    setMessage('')
    setIsDeleting(true)

    try {
      await onConfirm()
      onClose()
    } catch {
      setMessage("Couldn't delete this conversation. Try again.")
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Dialog open size="small" variant="neutral" onClose={onClose}>
      <Dialog.Header>
        Delete conversation
        <Dialog.Close />
      </Dialog.Header>
      <Dialog.Body>
        <Text variant="body-md" color="color-text-secondary">
          {`"${displayTitle(thread)}" and its answers will be deleted. This cannot be undone.`}
        </Text>
        {message && (
          <Text variant="body-sm" color="color-danger-60" role="alert">
            {message}
          </Text>
        )}
      </Dialog.Body>
      <Dialog.Footer />
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={onClose}>Cancel</Dialog.ActionTertiary>
        <Dialog.ActionPrimary onClick={confirm} loading={isDeleting}>
          Delete
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
